/* Homenetics inquiry measurement: confirmed native/Shopify Forms submissions. 2026-10-09. */
(function () {
  'use strict';
  if (window.HomeneticsInquiry) return;
  var KEY = 'homenetics_inquiry_v1';
  var TTL = 30 * 60 * 1000;
  var GA = 'G-BCZXRC88WT';
  var ADS = 'AW-11404645772';
  var LABEL = ADS + '/aNmZCOqajZcdEIyrlL4q';
  var FORM_IDS = ['1190634', '1190637'];
  var pending = null;
  var configured = { ga: false, ads: false };
  var privacyRequested = false;
  var retries = 0;
  var retryTimer = null;
  var boundForms = new WeakSet();
  var observedRoots = new WeakSet();
  var seenEmbeds = new WeakSet();
  var boundIds = {};
  var discoveryTimer = null;
  var discoveryRuns = 0;

  function supported(id) {
    return id === 'contact_form_page' || id === 'wiq-quote-form' ||
      id === 'shopify_forms_1190634' || id === 'shopify_forms_1190637';
  }
  function fresh(record) {
    return record && supported(record.form) && typeof record.id === 'string' &&
      record.id.length > 0 && record.id.length < 100 && typeof record.at === 'number' &&
      typeof record.confirmed === 'boolean' && typeof record.ga === 'boolean' &&
      typeof record.ads === 'boolean' && (record.qa === undefined || typeof record.qa === 'boolean') &&
      Date.now() >= record.at && Date.now() - record.at < TTL;
  }
  function isQuote(id) { return id === 'wiq-quote-form' || id === 'shopify_forms_1190637'; }
  function query() {
    try { return new URLSearchParams(window.location.search || ''); } catch (ignore) { return null; }
  }
  function qaVisit() {
    var params = query();
    return !!params && params.has('codex_qa');
  }
  function diagnostics() {
    try {
      var root = document.documentElement;
      if (!root) return;
      root.setAttribute('data-homenetics-inquiry-state', pending ? (pending.confirmed ? 'confirmed' : 'pending') : 'idle');
      root.setAttribute('data-homenetics-inquiry-form', pending ? pending.form : '');
      root.setAttribute('data-homenetics-inquiry-qa', pending && pending.qa ? 'true' : 'false');
      root.setAttribute('data-homenetics-inquiry-ga', pending && pending.ga ? (pending.qa ? 'qa-queued' : 'queued') : 'not-queued');
      root.setAttribute('data-homenetics-inquiry-ads', pending && pending.qa && pending.confirmed ? 'skipped-qa' : (pending && pending.ads ? 'queued' : 'not-queued'));
      root.setAttribute('data-homenetics-forms-bound', FORM_IDS.filter(function (id) { return boundIds[id]; }).join(','));
    } catch (ignore) { /* Diagnostics never contain field values or attempt IDs. */ }
  }
  try { pending = JSON.parse(sessionStorage.getItem(KEY)); } catch (ignore) {}
  if (!fresh(pending)) pending = null;
  function persist() {
    try {
      if (pending) sessionStorage.setItem(KEY, JSON.stringify(pending));
      else sessionStorage.removeItem(KEY);
    } catch (ignore) { /* Tracking must never prevent form delivery. */ }
    diagnostics();
  }
  function begin(form) {
    if (!supported(form)) return null;
    var id;
    try { id = window.crypto.randomUUID(); } catch (ignore) {
      id = 'inquiry-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
    }
    pending = { id: id, form: form, at: Date.now(), confirmed: false, ga: false, ads: false, qa: qaVisit() };
    retries = 0;
    persist();
    return id;
  }
  function allowed(method) {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !!privacy && typeof privacy[method] === 'function' && privacy[method]() === true;
    } catch (ignore) { return false; }
  }
  function requestPrivacy() {
    var shopify = window.Shopify;
    if (!privacyRequested && shopify && !shopify.customerPrivacy && typeof shopify.loadFeatures === 'function') {
      privacyRequested = true;
      shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (!error) flush();
      });
    }
  }
  function flush() {
    try { flushSafely(); } catch (ignore) { /* Measurement cannot change a form's result. */ }
    diagnostics();
  }
  function flushSafely() {
    if (pending && !fresh(pending)) { pending = null; persist(); }
    requestPrivacy();
    var tag = window.gtag;
    if (typeof tag !== 'function') return;
    var gaAllowed = allowed('analyticsProcessingAllowed');
    var adsAllowed = allowed('marketingAllowed');
    // Reuse the existing loader and preserve Shopify consent; no synthetic page view.
    if (gaAllowed && !configured.ga) {
      configured.ga = true;
      tag('config', GA, { send_page_view: false });
    }
    if (adsAllowed && !configured.ads) {
      configured.ads = true;
      tag('config', ADS, { send_page_view: false });
    }
    if (!pending || !pending.confirmed) return;
    // A QA page must not flush a restored, unsent production attempt either.
    if (qaVisit() && !pending.qa) return;
    if (gaAllowed && !pending.ga) {
      pending.ga = true;
      persist();
      var parameters = { send_to: GA, form_id: pending.form, lead_type: isQuote(pending.form) ? 'quote_request' : 'contact' };
      if (pending.qa) parameters.test_submission = true;
      // QA uses its own non-key event, never generate_lead or an Ads conversion.
      tag('event', pending.qa ? 'homenetics_inquiry_qa' : 'generate_lead', parameters);
    }
    if (pending.qa) {
      if (!pending.ads) { pending.ads = true; persist(); }
    } else if (adsAllowed && !pending.ads) {
      pending.ads = true;
      persist();
      tag('event', 'conversion', { send_to: LABEL, transaction_id: pending.id, value: 0, currency: 'USD' });
    }
  }
  function confirm(form, id) {
    if (!fresh(pending) || pending.form !== form || pending.id !== id) return;
    pending.confirmed = true;
    persist();
    flush();
    schedule();
  }
  function fail(form, id) {
    if (pending && pending.form === form && pending.id === id && !pending.confirmed) {
      pending = null;
      persist();
    }
  }
  function schedule() {
    if (retryTimer || retries >= 30) return;
    retryTimer = window.setTimeout(function () {
      retryTimer = null;
      retries += 1;
      flush();
      if (!configured.ga || !configured.ads || (pending && pending.confirmed && (!pending.ga || !pending.ads))) schedule();
    }, 1000);
  }

  function fieldValue(form, selector) {
    var field = form.querySelector(selector);
    return field && typeof field.value === 'string' ? field.value.trim() : '';
  }
  function plausibleFormsSubmission(form, id) {
    // The real Forms markup has novalidate and no required attributes. These are
    // conservative empty-field checks, not a replacement for the app's validation.
    if (!fieldValue(form, '[id="first_name"]') || !fieldValue(form, '[id="email"]') ||
        !fieldValue(form, '[id="phone_number"]')) return false;
    if (typeof form.checkValidity === 'function' && !form.checkValidity()) return false;
    if (id === '1190634') return !!fieldValue(form, 'textarea[name="custom#message"]');
    return !!fieldValue(form, '[id="custom#zip_postal_code"]') &&
      !!fieldValue(form, 'textarea[name="custom#quote_configuration"]');
  }
  function armFormsSubmission(form, id) {
    var key = 'shopify_forms_' + id;
    if (!plausibleFormsSubmission(form, id)) {
      if (pending && pending.form === key) fail(key, pending.id);
      return;
    }
    // Repeated submit events from one rapid double-click share one attempt.
    if (fresh(pending) && pending.form === key && !pending.confirmed && Date.now() - pending.at < 1500) return;
    begin(key);
  }
  function discoverForms() {
    FORM_IDS.forEach(function (id) {
      boundIds[id] = false;
      var containers = document.querySelectorAll('div[data-forms-id="forms-root-' + id + '"]');
      Array.prototype.forEach.call(containers, function (container) {
        var embed = container.querySelector('shopify-forms-embed');
        if (embed && !seenEmbeds.has(embed)) {
          seenEmbeds.add(embed);
          discoveryRuns = 0; // A replacement host gets its own bounded attachment window.
        }
        var root = embed && embed.shadowRoot;
        if (!root) return; // Only the app's exposed open shadow root is used.
        if (!observedRoots.has(root) && typeof MutationObserver === 'function') {
          observedRoots.add(root);
          new MutationObserver(discoverForms).observe(root, { childList: true, subtree: true });
        }
        var form = root.querySelector('form[data-testid="form"]');
        if (!form) return;
        boundIds[id] = true;
        if (boundForms.has(form)) return;
        boundForms.add(form);
        form.addEventListener('submit', function (event) {
          if (event.target !== form) return;
          try { armFormsSubmission(form, id); } catch (ignore) {}
        }, true);
        form.addEventListener('invalid', function () {
          var key = 'shopify_forms_' + id;
          if (pending && pending.form === key) fail(key, pending.id);
        }, true);
      });
    });
    diagnostics();
  }
  function hasUnboundForms() {
    return FORM_IDS.some(function (id) {
      var containers = document.querySelectorAll('div[data-forms-id="forms-root-' + id + '"]');
      return Array.prototype.some.call(containers, function (container) {
        var embed = container.querySelector('shopify-forms-embed');
        var root = embed && embed.shadowRoot;
        var form = root && root.querySelector('form[data-testid="form"]');
        return !form || !boundForms.has(form);
      });
    });
  }
  function discoverLater() {
    if (discoveryTimer || discoveryRuns >= 120) return;
    discoveryTimer = window.setTimeout(function () {
      discoveryTimer = null;
      discoveryRuns += 1;
      discoverForms();
      if (hasUnboundForms()) discoverLater();
    }, 500);
  }
  function confirmFormsRedirect() {
    if (!window.location || window.location.pathname !== '/pages/inquiry-received') return;
    var params = query();
    if (!params || params.getAll('form').length !== 1) return;
    var type = params.get('form');
    var expected = type === 'contact' ? 'shopify_forms_1190634' : (type === 'quote' ? 'shopify_forms_1190637' : null);
    if (!expected || !fresh(pending) || pending.form !== expected || pending.confirmed || (qaVisit() && !pending.qa)) return;
    // A typed/direct thank-you URL with a pending attempt is not a receipt.
    // Fail closed if the browser/app suppresses the same-origin source referrer.
    try {
      var referrer = new URL(document.referrer);
      if (referrer.origin !== window.location.origin) return;
      var validSource = type === 'contact' ?
        (referrer.pathname === '/pages/contact' || referrer.pathname === '/pages/contact-inquiry') :
        referrer.pathname === '/pages/product-quote-request';
      if (!validSource) return;
    } catch (ignore) { return; }
    confirm(expected, pending.id);
  }
  window.HomeneticsInquiry = { begin: begin, confirm: confirm, fail: fail };
  document.addEventListener('submit', function (event) {
    var form = event.target;
    // Preserve native contact and WIQ integration. WIQ itself starts after validation.
    if (form && form.id === 'contact_form_page' && form.checkValidity()) begin(form.id);
  }, true);
  document.addEventListener('visitorConsentCollected', function () { retries = 0; flush(); schedule(); });
  function boot() {
    if (!pending) persist();
    confirmFormsRedirect();
    if (pending && !pending.confirmed && (pending.form === 'contact_form_page' || pending.form === 'wiq-quote-form')) {
      var form = document.getElementById(pending.form);
      var marker = pending.form === 'wiq-quote-form' ? '[data-wiq-success]' : '.t4s-form-message--success[data-form-status]';
      if (form && form.querySelector(marker)) confirm(pending.form, pending.id);
      else if (form && form.querySelector('.t4s-form-message--error, [data-wiq-server-error]')) fail(pending.form, pending.id);
    }
    discoverForms();
    discoverLater();
    if (typeof MutationObserver === 'function' && document.documentElement) {
      new MutationObserver(function () { discoverForms(); discoverLater(); }).observe(document.documentElement, { childList: true, subtree: true });
    }
    flush();
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
}());

/* WIQ -> Shopify Forms 1190637. Public DOM only; never submits or records a conversion. */
(function () {
  'use strict';
  if (window.HomeneticsQuoteBridge) return;
  var KEY = 'homenetics_quote_draft_v1';
  var PATH = '/pages/product-quote-request';
  var TTL = 30 * 60 * 1000;
  // Saved Forms settings; the app does not expose these limits as maxLength.
  var declaredLimits = { configuration: 20000, cart: 20000, message: 1000 };
  var fieldLabels = { configuration: 'Quote configuration', cart: 'Cart details', message: 'Message' };
  var selectors = {
    first_name: '[id="first_name"]',
    email: '[id="email"]',
    phone_number: '[id="phone_number"]',
    zip: '[id="custom#zip_postal_code"]',
    configuration: 'textarea[name="custom#quote_configuration"]',
    address: '[id="custom#address"]',
    installation: '[id="custom#installation_service"]',
    message: 'textarea[name="custom#message"]',
    cart: 'textarea[name="custom#cart_details"]'
  };
  var state = { draft: null, form: null, ready: false, busy: false, touched: {}, tries: 0, observer: null };

  function qaVisit() {
    try { return new URLSearchParams(window.location.search || '').has('codex_qa'); }
    catch (ignore) { return false; }
  }

  function clear() {
    try { window.sessionStorage.removeItem(KEY); } catch (ignore) {}
    state.draft = null;
  }
  function load() {
    var item;
    try { item = JSON.parse(window.sessionStorage.getItem(KEY)); } catch (ignore) { return null; }
    if (!item || item.version !== 1 || item.origin !== window.location.origin ||
        item.formId !== '1190637' || typeof item.createdAt !== 'number' ||
        Date.now() < item.createdAt || Date.now() - item.createdAt >= TTL ||
        !item.fields || typeof item.fields.configuration !== 'string') {
      if (item) clear();
      return null;
    }
    return item;
  }
  function saveAndNavigate(fields, configuration) {
    if (!fields || !fields.configuration || !configuration || !configuration.product ||
        !configuration.variant || !configuration.variant.id) {
      return { ok: false, error: 'Please reopen the quote from the product and check your selected options.' };
    }
    var draft = { version: 1, formId: '1190637', origin: window.location.origin, qa: qaVisit(),
      createdAt: Date.now(), fields: fields, configuration: configuration };
    var encoded = JSON.stringify(draft);
    try {
      window.sessionStorage.setItem(KEY, encoded);
      if (window.sessionStorage.getItem(KEY) !== encoded) throw new Error('Storage verification failed');
    } catch (ignore) {
      return { ok: false, error: 'Your browser could not keep the request for the next step. Your details are still here. Please enable storage for this site and try again.' };
    }
    // Relative destination retains the exact origin. No contact/configuration data in the URL.
    try { window.location.assign(PATH + (draft.qa ? '?codex_qa=wiq_quote_review' : '')); }
    catch (ignore) { return { ok: false, error: 'Your request is saved in this tab, but the review page could not open. Please try again.' }; }
    return { ok: true };
  }
  function findForm() {
    var mount = document.querySelector('div[data-forms-id="forms-root-1190637"]');
    var host = mount && mount.querySelector('shopify-forms-embed');
    return host && host.shadowRoot && host.shadowRoot.querySelector('form[data-testid="form"]');
  }
  function recovery(message) {
    if (!state.draft) return;
    var box = document.getElementById('homenetics-quote-recovery');
    if (!box) {
      box = document.createElement('section');
      box.id = 'homenetics-quote-recovery';
      box.setAttribute('aria-label', 'Saved quote request');
      box.style.cssText = 'max-width:760px;margin:20px auto;padding:20px;border:1px solid #b8b8b8;background:#fff;color:#222;';
      var status = document.createElement('p');
      status.setAttribute('role', 'alert');
      status.setAttribute('data-quote-transfer-status', '');
      box.appendChild(status);
      var details = document.createElement('details');
      var summary = document.createElement('summary');
      summary.textContent = 'View or copy your saved request';
      details.appendChild(summary);
      var copy = document.createElement('textarea');
      copy.readOnly = true;
      copy.rows = 12;
      copy.style.cssText = 'display:block;width:100%;margin-top:12px;';
      copy.setAttribute('aria-label', 'Saved request for copying');
      var f = state.draft.fields;
      copy.value = 'Name: ' + f.first_name + '\nEmail: ' + f.email + '\nPhone: ' + f.phone_number +
        '\nZIP / postal code: ' + f.zip + '\nAddress: ' + f.address +
        '\nInstallation service: ' + f.installation + '\nMessage: ' + f.message + '\n\n' + f.configuration +
        (f.cart ? '\n\nCart details:\n' + f.cart : '');
      details.appendChild(copy);
      box.appendChild(details);
      var retry = document.createElement('button');
      retry.type = 'button';
      retry.textContent = 'Retry transferring my request';
      retry.addEventListener('click', function () { state.tries = 0; state.busy = false; transfer(); });
      box.appendChild(retry);
      var manual = document.createElement('button');
      manual.type = 'button';
      manual.textContent = 'I copied and reviewed the form below';
      manual.addEventListener('click', function () {
        var form = findForm();
        var config = form && form.querySelector(selectors.configuration);
        if (!config || !String(config.value || '').trim()) {
          recovery('Please copy your saved configuration into the Quote configuration field before sending. Nothing has been sent.');
          return;
        }
        Object.keys(selectors).forEach(function (key) { state.touched[key] = true; });
        state.ready = true;
        box.hidden = true;
      });
      box.appendChild(manual);
      var mount = document.querySelector('div[data-forms-id="forms-root-1190637"]');
      if (mount && mount.parentNode) mount.parentNode.insertBefore(box, mount);
      else (document.querySelector('main') || document.body).appendChild(box);
    }
    box.hidden = false;
    box.querySelector('[data-quote-transfer-status]').textContent = message + ' Nothing has been sent. Your saved request remains in this tab.';
  }
  function equivalent(key, actual, expected, form) {
    actual = String(actual == null ? '' : actual);
    expected = String(expected == null ? '' : expected);
    if (key === 'phone_number') {
      var actualDigits = actual.replace(/\D/g, '');
      var expectedDigits = expected.replace(/\D/g, '');
      if (actualDigits === expectedDigits) return true;
      var usDefault = form && form.querySelector('button[aria-label="Country code, United States +1"]');
      return !!usDefault && expectedDigits.length === 10 && actualDigits === '1' + expectedDigits;
    }
    return actual.replace(/\r\n/g, '\n') === expected.replace(/\r\n/g, '\n');
  }
  function prefillValue(key, value, form) {
    if (key !== 'phone_number' || !form.querySelector('button[aria-label="Country code, United States +1"]')) return value;
    // The Forms phone component requires an international value when populated.
    // Normalize only unambiguous US numbers; preserve other countries/extensions.
    var trimmed = value.trim();
    if (!/^[+\d\s().-]+$/.test(trimmed)) return value;
    var digits = trimmed.replace(/\D/g, '');
    if (digits.length === 11 && digits.charAt(0) === '1') return '+' + digits;
    if (trimmed.charAt(0) !== '+' && digits.length === 10) return '+1' + digits;
    return value;
  }
  function setField(el, value) {
    var proto = el.tagName === 'TEXTAREA' ? window.HTMLTextAreaElement.prototype : window.HTMLInputElement.prototype;
    var setter = Object.getOwnPropertyDescriptor(proto, 'value').set;
    setter.call(el, value);
    el.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
    el.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
  }
  function fieldsMatch(form) {
    return Object.keys(selectors).every(function (key) {
      var el = form.querySelector(selectors[key]);
      return el && (state.touched[key] || equivalent(key, el.value, state.draft.fields[key], form));
    });
  }
  function bind(form) {
    if (state.form === form) return;
    state.form = form;
    state.ready = false;
    state.touched = {};
    form.addEventListener('input', function (event) {
      if (!event.isTrusted) return;
      Object.keys(selectors).forEach(function (key) {
        if (form.querySelector(selectors[key]) === event.target) state.touched[key] = true;
      });
    }, true);
    form.addEventListener('submit', function (event) {
      if (state.ready && fieldsMatch(form)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      recovery('We could not verify the transfer of your request. Retry, or copy the saved details and review the form below.');
    }, true);
  }
  function transfer() {
    if (!state.draft || state.busy) return;
    var form = findForm();
    if (!form) {
      state.tries += 1;
      if (state.tries < 40) window.setTimeout(transfer, 250);
      else recovery('The quote form did not load. Please reload this page or retry transferring your request.');
      return;
    }
    if (state.form === form && state.ready) return;
    bind(form);
    state.busy = true;
    var keys = Object.keys(selectors);
    var index = 0;
    function fail(message) { state.busy = false; state.ready = false; recovery(message); }
    // Check every declared limit before changing any form control. Keep the full draft.
    var limitedKeys = Object.keys(declaredLimits);
    for (var limitIndex = 0; limitIndex < limitedKeys.length; limitIndex += 1) {
      var limitedKey = limitedKeys[limitIndex];
      var savedValue = String(state.draft.fields[limitedKey] == null ? '' : state.draft.fields[limitedKey]);
      if (savedValue.length > declaredLimits[limitedKey]) {
        fail(fieldLabels[limitedKey] + ' exceeds the form limit of ' + declaredLimits[limitedKey] +
          ' characters. Your complete request is saved below for copying; no text has been shortened.');
        return;
      }
    }
    function step() {
      if (findForm() !== form) { state.busy = false; window.setTimeout(transfer, 50); return; }
      if (index >= keys.length) {
        window.setTimeout(function () {
          var matches = fieldsMatch(form);
          state.busy = false;
          if (!matches) { fail('Some fields did not keep your saved details. Retry, or copy and review your request.'); return; }
          state.ready = true;
          var box = document.getElementById('homenetics-quote-recovery');
          if (box) box.hidden = true;
        }, 100);
        return;
      }
      var key = keys[index++];
      var el = form.querySelector(selectors[key]);
      var value = prefillValue(key, String(state.draft.fields[key] == null ? '' : state.draft.fields[key]), form);
      if (!el || el.disabled || (el.maxLength >= 0 && value.length > el.maxLength)) {
        fail('A required form field is unavailable or your configuration is too long for it. Please review your saved request.');
        return;
      }
      if (!state.touched[key]) {
        try { setField(el, value); }
        catch (ignore) { fail('Your browser could not transfer the saved request. Please copy and review the details below.'); return; }
      }
      // Let the form's controlled input update before filling the next field.
      window.setTimeout(step, 30);
    }
    step();
  }
  function boot() {
    // Parent-owned measurement helper runs first and marks a verified Forms return.
    // A URL alone never clears the personally identifiable saved request.
    var root = document.documentElement;
    if (window.location.pathname === '/pages/inquiry-received' && root &&
        root.getAttribute('data-homenetics-inquiry-state') === 'confirmed' &&
        root.getAttribute('data-homenetics-inquiry-form') === 'shopify_forms_1190637') {
      clear();
      return;
    }
    if (window.location.pathname.replace(/\/$/, '') !== PATH) return;
    state.draft = load();
    if (!state.draft) return;
    // A retained QA draft must stay a QA visit even if the review URL was reopened manually.
    if (state.draft.qa && !qaVisit()) {
      window.location.assign(PATH + '?codex_qa=wiq_quote_review');
      return;
    }
    transfer();
    // Detect replacement of the app host. Internal app state is never accessed.
    if (window.MutationObserver) {
      state.observer = new MutationObserver(function () {
        if (findForm() !== state.form && !state.busy) transfer();
      });
      state.observer.observe(document.body, { childList: true, subtree: true });
    }
  }
  window.HomeneticsQuoteBridge = { saveAndNavigate: saveAndNavigate, clear: clear, storageKey: KEY, formId: '1190637' };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();


/* WROUGHT IRON QUOTE START
 * Front-end controller for the Wrought Iron quote-only workflow.
 *
 * Responsibilities:
 *   1. Open a reusable quote modal when any .wiq-quote-trigger is clicked.
 *   2. Read the live product form (variant, quantity, Hulk Product Options,
 *      properties[...], radios, checkboxes, selects) via FormData + DOM scan.
 *   3. Show the captured configuration for review and write it into the hidden
 *      Shopify contact-form field. The product is NEVER added to the cart and
 *      NO Shopify order is created.
 *   4. Optionally include the current /cart.js contents (read-only) in the quote.
 *   5. Submit through Shopify's native contact form (AJAX-enhanced).
 *   6. THEME-LEVEL cart fallback: if a quote-only line is present in the cart or
 *      mini-cart, block the visible checkout path. This is a storefront-only
 *      guard, NOT server-side Shopify checkout validation.
 *
 * Everything here is namespaced (WIQ / wiq-) and never touches Kalles/Hulk/Globo
 * internals beyond reading the product form the customer already filled in.
 */
(function () {
  'use strict';

  // Quote-only products carry the single exact Shopify tag 'Quote Only'.
  // Detection itself happens server-side in Liquid; the JS keys off the
  // data-wiq-quote-line / .wiq-quote-trigger markers it renders.
  var QUOTE_TAG = 'Quote Only';

  /* ---------------------------------------------------------------- utils */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* ----------------------------------------------------- product capture */

  // Find the live add-to-cart form that applies to a trigger.
  function findProductForm(trigger) {
    // 1. A form the trigger lives inside (product page / QV / QS).
    var f = trigger.closest ? trigger.closest('form[data-type="add-to-cart-form"]') : null;
    if (f) return f;
    // 2. Sticky bar / detached triggers: prefer a form scoped to the same product.
    var pid = trigger.getAttribute('data-product-id');
    var forms = $all('form[data-type="add-to-cart-form"]');
    if (pid) {
      for (var i = 0; i < forms.length; i++) {
        if (forms[i].getAttribute('data-productid') === pid) return forms[i];
      }
    }
    // 3. Fall back to the main product form on the page.
    return forms[0] || null;
  }

  // Map a variant id to its title using the theme's inlined variant JSON.
  function variantTitleById(form, variantId) {
    try {
      var wrap = form.closest('[data-callBackVariant]') || document;
      var node = wrap.querySelector('.pr_variants_json') || document.querySelector('.pr_variants_json');
      if (!node) return '';
      var variants = JSON.parse(node.textContent || '[]');
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(variantId)) return variants[i].title || '';
      }
    } catch (e) { /* ignore */ }
    return '';
  }

  // Read human-readable native option selections from the theme swatch UI.
  function captureSwatchOptions(form) {
    var out = [];
    var scope = form.closest('[data-callBackVariant]') || document;
    $all('[data-swatch-option]', scope).forEach(function (opt) {
      var titleEl = opt.querySelector('.t4s-swatch__title');
      var current = opt.querySelector('[data-current-value]');
      if (!titleEl) return;
      var label = (titleEl.textContent || '').split(':')[0].trim();
      var value = current ? (current.textContent || '').trim() : '';
      if (label && value) out.push({ label: label, value: value });
    });
    return out;
  }

  /* ---- Hulk Product Options capture ------------------------------------
   * Ported from the theme's hulk-product-options.js collectHulkProperties()
   * so the modal shows exactly what Hulk would submit. Reads the live
   * .hulkapps_product_options container directly (Hulk keeps selections there
   * and only syncs them into the form on ATC click/submit — which never fires
   * for Quote Only products). Adds text/textarea/file handling on top. */
  function cleanText(s) {
    return String(s == null ? '' : s)
      .replace(/^\s*[-–—]\s*/, '')
      .replace(/\*/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function hulkOptionName(option) {
    var hidden = option.querySelector('input[type="hidden"][name^="properties["]');
    if (hidden) {
      var m = hidden.name.match(/^properties\[(.+)\]$/);
      if (m) return cleanText(m[1]);
    }
    var t = option.querySelector('.hulkapps_option_name, .hulkapps_option_label, .hulkapps_option_title, .hulkapps_label');
    return t ? cleanText(t.textContent) : '';
  }

  // Returns value, appending any visible price adjustment as " [ $X.XX ]".
  function hulkPricedValue(source, fallback) {
    if (!source) return cleanText(fallback);
    var value = cleanText(fallback || source.value || source.getAttribute('value') ||
      source.getAttribute('data-conditional-value') || source.textContent);
    if (!value) return '';
    if (/\[\s*\$?[\d,]+(?:\.\d{2})?\s*\]/.test(value)) return value;
    var price = parseFloat(source.getAttribute('data-price')) || 0;
    if (!price && source.closest) {
      var p = source.closest('[data-price]');
      if (p) price = parseFloat(p.getAttribute('data-price')) || 0;
    }
    return price > 0 ? value + ' [ $' + price.toFixed(2) + ' ]' : value;
  }

  // Ordered [{label,value}], no empties, no duplicate labels.
  function captureHulkOptions() {
    var container = document.querySelector('.hulkapps_product_options');
    if (!container) return [];
    var order = [], map = {};
    function add(name, value) {
      name = cleanText(name); value = cleanText(value);
      if (!name || !value) return;
      if (!(name in map)) order.push(name);
      map[name] = value;
    }
    // Authoritative hidden properties Hulk maintains.
    $all('input[type="hidden"][name^="properties["]', container).forEach(function (input) {
      var m = input.name.match(/^properties\[(.+)\]$/);
      if (m && !/^_/.test(m[1])) add(m[1], input.value);
    });
    // Per-option readable values (with price adjustments) incl. text/file.
    $all('.hulkapps_option', container).forEach(function (option) {
      if (option.classList.contains('information_render')) return;
      if (option.offsetParent === null || option.style.display === 'none') return;
      var name = hulkOptionName(option);
      if (!name) return;

      var selBtn = option.querySelector('.hulk_po_radio.button_selected, .hulk_po_radio.swatch_selected');
      if (selBtn) { add(name, hulkPricedValue(selBtn.querySelector('input[type="radio"]') || selBtn)); return; }

      var checkedRadio = option.querySelector('input[type="radio"]:checked');
      if (checkedRadio) { add(name, hulkPricedValue(checkedRadio)); return; }

      var cbs = [];
      $all('input[type="checkbox"]:checked', option).forEach(function (i) {
        var v = hulkPricedValue(i);
        if (v && cbs.indexOf(v) === -1) cbs.push(v);
      });
      if (cbs.length) { add(name, cbs.join(', ')); return; }

      var sel = option.querySelector('select.hulkapps_option_child, select');
      if (sel && sel.selectedIndex >= 0) {
        var so = sel.options[sel.selectedIndex];
        add(name, hulkPricedValue(so, so.text || so.value)); return;
      }

      var txt = option.querySelector('textarea, input[type="text"], input[type="email"], input[type="number"], input[type="tel"]');
      if (txt && cleanText(txt.value)) { add(name, txt.value); return; }

      var file = option.querySelector('input[type="file"]');
      if (file) {
        var fileNames = file.files && file.files.length
          ? Array.prototype.map.call(file.files, function (f) { return f.name; }).join(', ') : '';
        var urlInput = option.querySelector('input[type="hidden"][name^="properties["]');
        add(name, fileNames || (urlInput && urlInput.value) || '');
      }
    });
    return order.map(function (n) { return { label: n, value: map[n] }; });
  }

  function captureConfig(form, trigger) {
    var cfg = {
      product: {
        title: trigger.getAttribute('data-product-title') || document.title,
        url: trigger.getAttribute('data-product-url') || (form ? form.getAttribute('action') : ''),
        id: form ? form.getAttribute('data-productid') : ''
      },
      variant: { id: '', title: '' },
      quantity: '1',
      options: [],     // native Shopify variant options (Color/Size…)
      hulk: [],        // Hulk Product Options (authoritative, from Hulk container)
      properties: [],  // any remaining non-Hulk properties[...] line items
      cart: null
    };

    if (!form) return cfg;

    var idField = form.querySelector('[name="id"]');
    if (idField) cfg.variant.id = idField.value;
    cfg.variant.title = variantTitleById(form, cfg.variant.id);

    var qtyField = form.querySelector('[name="quantity"]');
    if (qtyField && qtyField.value) cfg.quantity = qtyField.value;

    // Native Shopify variant option selections (Color/Size/etc.) from swatch UI.
    cfg.options = captureSwatchOptions(form);

    // Hulk Product Options — read directly from the live Hulk container so every
    // selected option is captured even though Hulk hasn't synced them to the form.
    cfg.hulk = captureHulkOptions();

    // Any remaining line-item properties[...] on the form that are NOT Hulk
    // options (e.g. theme frm_properties). Dedupe by label, skip private/empty
    // and Shopify technical fields.
    var hulkLabels = {};
    cfg.hulk.forEach(function (o) { hulkLabels[o.label.toLowerCase()] = true; });
    var seenProp = {};
    try {
      var fd = new FormData(form);
      fd.forEach(function (value, name) {
        if (value == null || cleanText(value) === '') return;
        if (['id', 'quantity', 'form_type', 'utf8', 'product-id', 'add'].indexOf(name) !== -1) return;
        var m = name.match(/^properties\[(.+)\]$/);
        if (!m) return;                                   // ignore non-property technical fields
        var label = m[1];
        if (/^_/.test(label)) return;                     // skip private line-item props
        if (hulkLabels[cleanText(label).toLowerCase()]) return; // already have it from Hulk
        var key = cleanText(label).toLowerCase();
        if (seenProp[key]) return;
        seenProp[key] = true;
        cfg.properties.push({ label: cleanText(label), value: cleanText(value) });
      });
    } catch (e) { /* ignore */ }

    return cfg;
  }

  /* ------------------------------------------------------------- cart read */
  function fetchCart() {
    return fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart.js', {
      headers: { 'Accept': 'application/json' }, credentials: 'same-origin'
    }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }

  function money(cents) {
    if (typeof cents !== 'number') return '';
    try { return '$' + (cents / 100).toFixed(2); } catch (e) { return String(cents); }
  }

  /* --------------------------------------------------------- serialisation */
  function configToText(cfg) {
    var lines = [];
    lines.push('QUOTE REQUEST — WROUGHT IRON DOOR');
    lines.push('Product: ' + cfg.product.title);
    if (cfg.product.url) lines.push('URL: ' + cfg.product.url);
    if (cfg.product.id) lines.push('Product ID: ' + cfg.product.id);
    if (cfg.variant.id) lines.push('Variant ID: ' + cfg.variant.id);
    if (cfg.variant.title) lines.push('Variant: ' + cfg.variant.title);
    lines.push('Quantity: ' + cfg.quantity);
    if (cfg.options.length) {
      lines.push('');
      lines.push('Selected options:');
      cfg.options.forEach(function (o) { lines.push('  - ' + o.label + ': ' + o.value); });
    }
    if (cfg.hulk && cfg.hulk.length) {
      lines.push('');
      lines.push('Product options (Hulk):');
      cfg.hulk.forEach(function (o) { lines.push('  - ' + o.label + ': ' + o.value); });
    }
    if (cfg.properties.length) {
      lines.push('');
      lines.push('Configuration fields:');
      cfg.properties.forEach(function (p) { lines.push('  - ' + p.label + ': ' + p.value); });
    }
    if (cfg.cart && cfg.cart.items && cfg.cart.items.length) {
      lines.push('');
      lines.push('Items currently in customer cart (' + cfg.cart.item_count + '):');
      cfg.cart.items.forEach(function (it) {
        lines.push('  - ' + it.quantity + ' x ' + it.product_title + (it.variant_title ? ' / ' + it.variant_title : '') + ' @ ' + money(it.price) + ' = ' + money(it.line_price));
        if (it.properties) {
          Object.keys(it.properties).forEach(function (k) {
            if (/^_/.test(k)) return;
            lines.push('      ' + k + ': ' + it.properties[k]);
          });
        }
      });
      lines.push('  Cart total: ' + money(cfg.cart.total_price));
    }
    return lines.join('\n');
  }

  function renderReview(cfg, includeCart) {
    var html = '<ul class="wiq-config__list">';
    html += '<li><span class="wiq-config__key">Product</span><span class="wiq-config__val">' + escapeHtml(cfg.product.title) + '</span></li>';
    if (cfg.variant.title) html += '<li><span class="wiq-config__key">Variant</span><span class="wiq-config__val">' + escapeHtml(cfg.variant.title) + '</span></li>';
    html += '<li><span class="wiq-config__key">Quantity</span><span class="wiq-config__val">' + escapeHtml(cfg.quantity) + '</span></li>';
    cfg.options.forEach(function (o) {
      html += '<li><span class="wiq-config__key">' + escapeHtml(o.label) + '</span><span class="wiq-config__val">' + escapeHtml(o.value) + '</span></li>';
    });
    html += '</ul>';
    if (cfg.hulk && cfg.hulk.length) {
      html += '<div class="wiq-config__group-title">Product options</div><ul class="wiq-config__list">';
      cfg.hulk.forEach(function (o) {
        html += '<li><span class="wiq-config__key">' + escapeHtml(o.label) + '</span><span class="wiq-config__val">' + escapeHtml(o.value) + '</span></li>';
      });
      html += '</ul>';
    }
    if (cfg.properties.length) {
      html += '<ul class="wiq-config__list">';
      cfg.properties.forEach(function (p) {
        html += '<li><span class="wiq-config__key">' + escapeHtml(p.label) + '</span><span class="wiq-config__val">' + escapeHtml(p.value) + '</span></li>';
      });
      html += '</ul>';
    }
    if (includeCart && cfg.cart && cfg.cart.items && cfg.cart.items.length) {
      html += '<div class="wiq-config__group-title">Cart items included (' + cfg.cart.item_count + ')</div><ul class="wiq-config__list">';
      cfg.cart.items.forEach(function (it) {
        html += '<li><span class="wiq-config__key">' + escapeHtml(it.quantity + ' x ' + it.product_title) + '</span><span class="wiq-config__val">' + escapeHtml(money(it.line_price)) + '</span></li>';
      });
      html += '</ul>';
    }
    return html;
  }

  /* --------------------------------------------------------------- modal */
  var Modal = {
    el: null, dialog: null, lastFocus: null, currentCfg: null,

    init: function () {
      this.el = $('[data-wiq-modal]');
      if (!this.el) return;
      this.dialog = $('[data-wiq-dialog]', this.el);
      var self = this;

      $all('[data-wiq-close]', this.el).forEach(function (b) {
        b.addEventListener('click', function () { self.close(); });
      });
      var overlay = $('[data-wiq-overlay]', this.el);
      if (overlay) overlay.addEventListener('click', function () { self.close(); });

      document.addEventListener('keydown', function (e) {
        if (self.isOpen() && (e.key === 'Escape' || e.key === 'Esc')) { self.close(); }
        if (self.isOpen() && e.key === 'Tab') { self.trapFocus(e); }
      });

      // Cart-inclusion live preview.
      var cartToggle = $('[data-wiq-include-cart]', this.el);
      if (cartToggle) {
        cartToggle.addEventListener('change', function () {
          if (cartToggle.checked && self.currentCfg && !self.currentCfg.cart) {
            fetchCart().then(function (cart) {
              if (self.currentCfg) { self.currentCfg.cart = cart; self.refresh(cartToggle.checked); }
            });
          } else {
            self.refresh(cartToggle.checked);
          }
        });
      }

      this.form = $('[data-wiq-form]', this.el);
      if (this.form) this.form.addEventListener('submit', function (e) { self.onSubmit(e); });

      // Native contact success (no-JS / full-page fallback): keep modal open on load.
      if ($('[data-wiq-success]', this.el)) { this.open(null, null); }
    },

    isOpen: function () { return this.el && !this.el.hasAttribute('hidden'); },

    refresh: function (includeCart) {
      var review = $('[data-wiq-config-review]', this.el);
      if (review && this.currentCfg) review.innerHTML = renderReview(this.currentCfg, includeCart);
      this.writeHidden(includeCart);
    },

    writeHidden: function (includeCart) {
      if (!this.currentCfg) return;
      var cfg = this.currentCfg;
      var payload = { include_cart: !!includeCart };
      ['product', 'variant', 'quantity', 'options', 'hulk', 'properties'].forEach(function (k) { payload[k] = cfg[k]; });
      if (includeCart) payload.cart = cfg.cart;
      var field = $('[data-wiq-config-field]', this.el);
      if (field) field.value = JSON.stringify(payload);
      var body = $('[data-wiq-body]', this.el);
      if (body) {
        var withCart = Object.assign({}, cfg, { cart: includeCart ? cfg.cart : null });
        body.value = configToText(withCart);
      }
    },

    open: function (form, trigger) {
      if (!this.el) return;
      this.lastFocus = document.activeElement;
      if (trigger) {
        this.currentCfg = captureConfig(form, trigger);
        var toggle = $('[data-wiq-include-cart]', this.el);
        this.refresh(toggle && toggle.checked);
      }
      this.el.removeAttribute('hidden');
      this.el.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      var focusTarget = $('[data-wiq-close]', this.el) || this.dialog;
      if (focusTarget) focusTarget.focus();
    },

    close: function () {
      if (!this.el) return;
      this.el.setAttribute('hidden', '');
      this.el.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    },

    focusable: function () {
      return $all('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])', this.dialog)
        .filter(function (el) { return el.offsetParent !== null; });
    },

    trapFocus: function (e) {
      var f = this.focusable();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    },

    validate: function () {
      var errs = [];
      var req = [['[name="contact[name]"]', 'Name'], ['[name="contact[email]"]', 'Email'],
                 ['[name="contact[phone]"]', 'Phone'], ['[name="contact[Delivery ZIP]"]', 'Delivery ZIP code']];
      var self = this;
      req.forEach(function (pair) {
        var el = $(pair[0], self.form);
        if (!el) return;
        var ok = el.value && el.value.trim() !== '';
        if (pair[0].indexOf('email') !== -1 && ok) ok = /.+@.+\..+/.test(el.value);
        el.setAttribute('aria-invalid', ok ? 'false' : 'true');
        if (!ok) errs.push(pair[1]);
      });
      return errs;
    },

    onSubmit: function (e) {
      e.preventDefault();
      var self = this;
      if (!this.form || this.submitting) return;
      var errors = this.validate();
      if (errors.length) { this.showError('Please complete: ' + errors.join(', ') + '.'); return; }
      if (!this.currentCfg || !this.currentCfg.product || !this.currentCfg.variant || !this.currentCfg.variant.id) {
        this.showError('Please reopen the quote from the product and check your selected options.'); return;
      }
      var bridge = window.HomeneticsQuoteBridge;
      if (!bridge) { this.showError('The next step could not load. Your details are still here. Please try again.'); return; }
      var toggle = $('[data-wiq-include-cart]', this.el);
      var includeCart = !!(toggle && toggle.checked);
      var button = $('[data-wiq-submit]', this.form);
      var spinner = button ? $('.wiq-btn__spinner', button) : null;
      this.submitting = true;
      if (button) button.disabled = true;
      if (spinner) spinner.hidden = false;
      function reset(message) {
        self.submitting = false;
        if (button) button.disabled = false;
        if (spinner) spinner.hidden = true;
        if (message) self.showError(message);
      }
      function field(name) {
        var el = self.form.querySelector('[name="contact[' + name + ']"]');
        return el ? String(el.value || '').trim() : '';
      }
      function proceed() {
        // Full original configuration, including cart only when explicitly selected.
        self.writeHidden(includeCart);
        var cfg = self.currentCfg;
        var payload = { include_cart: includeCart };
        ['product', 'variant', 'quantity', 'options', 'hulk', 'properties'].forEach(function (key) { payload[key] = cfg[key]; });
        if (includeCart) payload.cart = cfg.cart;
        var selection = self.form.querySelector('[name="contact[Installation Required]"]:checked');
        var readable = configToText(Object.assign({}, cfg, { cart: includeCart ? cfg.cart : null }));
        var fields = {
          first_name: field('name'), email: field('email'), phone_number: field('phone'),
          zip: field('Delivery ZIP'), address: field('Delivery Address'),
          installation: selection ? selection.value : '', message: field('Additional Comments'),
          configuration: readable + '\n\nConfiguration JSON:\n' + JSON.stringify(payload, null, 2),
          cart: includeCart ? JSON.stringify(cfg.cart, null, 2) : ''
        };
        try {
          var result = bridge.saveAndNavigate(fields, payload);
          // Reset even after navigation starts so browser Back can retry normally.
          reset(result.ok ? '' : result.error);
        } catch (ignore) { reset('Your request could not move to the next step. Your details are still here. Please try again.'); }
      }
      if (includeCart) {
        // Re-read at the handoff, not the older preview snapshot.
        fetchCart().then(function (cart) {
          if (!cart || !Array.isArray(cart.items)) { reset('Your cart could not be loaded. Please retry or uncheck Include cart items.'); return; }
          self.currentCfg.cart = cart;
          proceed();
        }).catch(function () { reset('Your cart could not be loaded. Please retry or uncheck Include cart items.'); });
      } else proceed();
    },

    showSuccess: function () {
      var body = this.form.querySelector('.wiq-form__grid');
      var actions = $('.wiq-form__actions', this.form);
      var msg = document.createElement('p');
      msg.className = 'wiq-form__success';
      msg.setAttribute('role', 'status');
      msg.textContent = 'Thank you — your quote request has been sent. We will be in touch shortly.';
      this.form.insertBefore(msg, this.form.firstChild);
      if (body) body.style.display = 'none';
      if (actions) actions.style.display = 'none';
      msg.focus && msg.focus();
    },

    showError: function (text) {
      var err = $('[data-wiq-client-error]', this.el);
      if (err) { err.hidden = false; err.textContent = text; }
    }
  };

  /* -------------------------------------------------- trigger delegation */
  function onTriggerClick(e) {
    var trigger = e.target.closest ? e.target.closest('.wiq-quote-trigger') : null;
    if (!trigger) return;
    // .wiq-quote-card-link is a plain navigation link (cards) — let it navigate.
    if (trigger.classList.contains('wiq-quote-card-link')) return;
    e.preventDefault();
    e.stopPropagation();
    var form = findProductForm(trigger);
    Modal.open(form, trigger);
  }

  /* ------------------------------------------- Quote Only submit guard ----
   * The native Add to Cart button stays in the DOM (Hulk needs it), but for
   * Quote Only products it is hidden + inert and NO form submission may reach
   * /cart/add — including programmatic .submit(), Enter-key, or a scripted
   * .click() on the hidden button. We block at both the submit and click level
   * in the capture phase so we run before the theme's / Hulk's own handlers.
   * This is theme-level enforcement, complementing the cart/mini-cart backstop. */
  function isQuoteOnlyForm(form) {
    if (!form || !form.matches) return false;
    if (!form.matches('form[data-type="add-to-cart-form"], form[action*="/cart/add"]')) return false;
    // Blocked when: WIQ quote product, OR a consultation-only (HNH) product whose
    // buttons wrapper currently carries .hnh-no-purchase (server-side StraJ/pivot,
    // or awning >= 9 ft toggled by JS).
    return !!(form.querySelector('[data-wiq-native-atc]') ||
              form.querySelector('.wiq-quote-trigger') ||
              form.querySelector('.t4s-product-form__buttons.hnh-no-purchase'));
  }

  function installQuoteFormGuards() {
    // Block any submission of a Quote Only product form.
    document.addEventListener('submit', function (e) {
      if (isQuoteOnlyForm(e.target)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      }
    }, true);

    // Block clicks/activation of the native ATC control inside a Quote Only form
    // (covers theme click-based Ajax add and scripted clicks). The visible
    // .wiq-quote-trigger is type="button" and is intentionally NOT matched here.
    document.addEventListener('click', function (e) {
      var atc = e.target.closest ? e.target.closest('[data-wiq-native-atc], button[name="add"], [data-atc-form]') : null;
      if (!atc || atc.classList.contains('wiq-quote-trigger')) return;
      var form = atc.closest('form[data-type="add-to-cart-form"], form[action*="/cart/add"]');
      if (isQuoteOnlyForm(form)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      }
    }, true);
  }

  /* ----------------------------------------------- HNH awning length gate --
   * Awning products (metal-awnings / retractable-awnings) stay purchasable at
   * 4–8 linear ft but become consultation-only at >= 9 ft. Length is a SHOPIFY
   * VARIANT option whose name differs per product, so we read the selected value
   * ("N linear feet") scoped to the length option and toggle .hnh-no-purchase on
   * the buttons wrapper (hides Add to Cart + dynamic checkout, arms the submit
   * guard) plus .hnh-purchase-blocked on <html> (hides the sticky ATC), and show
   * the consultation note. Re-evaluates whenever the selection changes. */
  function hnhSelectedLengthFt(scope) {
    if (!scope) return null;
    var opts = $all('[data-swatch-option]', scope);
    for (var i = 0; i < opts.length; i++) {
      var title = opts[i].querySelector('.t4s-swatch__title');
      if (title && /linear\s*f/i.test(title.textContent || '')) {
        var cur = opts[i].querySelector('[data-current-value]');
        var m = cur && (cur.textContent || '').match(/(\d+)\s*linear/i);
        if (m) return parseInt(m[1], 10);
      }
    }
    // Fallback: any current value shaped like "N linear feet".
    var vals = $all('[data-current-value]', scope);
    for (var j = 0; j < vals.length; j++) {
      var mm = (vals[j].textContent || '').match(/(\d+)\s+linear\s*f/i);
      if (mm) return parseInt(mm[1], 10);
    }
    return null;
  }

  function hnhApplyAwning(wrapper) {
    var form = wrapper.closest('form') || document;
    var len = hnhSelectedLengthFt(form);
    var blocked = len != null && len >= 9;
    wrapper.classList.toggle('hnh-no-purchase', blocked);
    var inModal = !!wrapper.closest('.mfp-content, .t4s-modal, [data-quickview], .t4s-quickview');
    if (!inModal) document.documentElement.classList.toggle('hnh-purchase-blocked', blocked);
    var note = wrapper.querySelector('[data-hnh-note]');
    if (note) note.hidden = !blocked;
  }

  function installAwningGate() {
    $all('.t4s-product-form__buttons[data-hnh-awning]').forEach(function (wrapper) {
      var form = wrapper.closest('form') || document;
      var run = function () { hnhApplyAwning(wrapper); };
      run(); // initial state (defaults to the first / smallest length = purchasable)
      if (window.MutationObserver) {
        var pending = null;
        // Watch text/child changes ([data-current-value] updates on selection) —
        // NOT attributes, to avoid reacting to our own class toggle.
        var mo = new MutationObserver(function () {
          clearTimeout(pending); pending = setTimeout(run, 80);
        });
        mo.observe(form, { subtree: true, childList: true, characterData: true });
      }
      form.addEventListener('change', function () { setTimeout(run, 30); });
      form.addEventListener('click', function (e) {
        if (e.target.closest('.t4s-swatch__item, [data-swatch-item], [data-dropdown-item]')) setTimeout(run, 60);
      });
    });
  }

  /* ---------------------------------------------- cart checkout fallback */
  var Cart = {
    NOTICE_ID: 'wiq-cart-notice',

    hasQuoteLine: function (root) {
      return !!(root || document).querySelector('[data-wiq-quote-line]');
    },

    apply: function () {
      // Operate on any cart context currently in the DOM (page cart + drawer).
      var containers = $all('form[action*="/cart"], [data-cart-form], #t4s-mini_cart, [data-cart-drawer], .t4s-mini_cart, .t4s-drawer__cart');
      var pageHasQuote = this.hasQuoteLine(document);

      // Block/enable each checkout form based on whether IT contains a quote line.
      $all('form[action*="/checkout"], form[action*="/cart"]').forEach(function (form) {
        var scope = form.closest('#t4s-mini_cart, [data-cart-drawer], .t4s-mini_cart, .t4s-drawer__cart, #MainContent') || document;
        var blocked = Cart.hasQuoteLine(scope) || pageHasQuote;
        Cart.toggleForm(form, blocked);
      });

      // Standalone accelerated checkout blocks not inside a form.
      $all('.additional-checkout-buttons, [data-shopify="dynamic-checkout-cart"]').forEach(function (el) {
        if (pageHasQuote) { el.style.pointerEvents = 'none'; el.style.opacity = '0.4'; }
      });

      this.renderNotices();
    },

    toggleForm: function (form, blocked) {
      form.classList.toggle('wiq-checkout-blocked', blocked);
      $all('[name="checkout"], .t4s-btn__checkout', form).forEach(function (btn) {
        if (blocked) { btn.setAttribute('disabled', 'disabled'); btn.setAttribute('aria-disabled', 'true'); }
        else { btn.removeAttribute('disabled'); btn.removeAttribute('aria-disabled'); }
      });
      if (blocked && !form.__wiqGuarded) {
        form.__wiqGuarded = true;
        form.addEventListener('submit', function (e) {
          if (form.classList.contains('wiq-checkout-blocked')) {
            var sn = e.submitter;
            if (!sn || sn.name === 'checkout' || (sn.className || '').indexOf('checkout') !== -1) {
              e.preventDefault();
              e.stopPropagation();
              return false;
            }
          }
        }, true);
      }
    },

    renderNotices: function () {
      // The cart sections render a server-side notice ([data-wiq-server-notice]).
      // Only inject a JS fallback notice on surfaces that lack one entirely.
      if (document.querySelector('[data-wiq-server-notice]')) return;
      $all('[data-wiq-quote-line]').forEach(function (line) {
        var container = line.closest('.t4s-mini_cart__items, .t4s-cart__items, form, [data-cart-drawer]') || line.parentNode;
        if (!container || container.querySelector('.wiq-cart-notice')) return;
        var reqUrl = line.getAttribute('data-wiq-quote-url') || '#';
        var notice = document.createElement('div');
        notice.className = 'wiq-cart-notice';
        notice.setAttribute('role', 'status');
        notice.innerHTML =
          'This door requires a confirmed price and freight quote before checkout. ' +
          'Request a quote for the door, or remove it to continue purchasing the other items in your cart.' +
          '<div class="wiq-cart-notice__actions">' +
          '<a class="wiq-btn wiq-btn--primary" href="' + escapeHtml(reqUrl) + '">Request Quote</a>' +
          '</div>';
        container.insertBefore(notice, container.firstChild);
      });
    }
  };

  /* --------------------------------------------------------------- boot */
  function boot() {
    Modal.init();
    installQuoteFormGuards();
    installAwningGate();
    document.addEventListener('click', onTriggerClick, false);

    Cart.apply();
    // Re-apply after AJAX cart/drawer refreshes.
    var target = document.body;
    if (target && window.MutationObserver) {
      var pending = null;
      var mo = new MutationObserver(function () {
        clearTimeout(pending);
        pending = setTimeout(function () { Cart.apply(); }, 120);
      });
      mo.observe(target, { childList: true, subtree: true });
    }
    ['cart:refresh', 'cart:updated', 'cart:build', 'ajaxProduct:added'].forEach(function (evt) {
      document.addEventListener(evt, function () { setTimeout(function () { Cart.apply(); }, 60); });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.WIQ = { Modal: Modal, Cart: Cart, captureConfig: captureConfig };
})();
/* WROUGHT IRON QUOTE END */
